export default [
    {
        path: '/bms/redirect/:path*',
        component: () => import('./bms/views/redirect/index')
    },
    {
        path: '/bms/index',
        name: 'bmsIndex',
        meta: { title: 'BMSLang.route.personManage', icon: 'dispatchPopup', system: 'bms' },
        component: () => import('./bms/views/Index')
    },
    {
        path: '/bms/bill',
        name: 'billIndex',
        meta: { title: 'BMSLang.route.bill', icon: 'bill', system: 'bms' },
        component: () => import('./bms/views/finance/bill/Index.vue')
    },
    {
        path: '/bms/billDetails',
        name: 'BillDetails',
        meta: { title: 'BMSLang.route.BillDetails', icon: 'BillDetails', system: 'bms' },
        component: () => import('./bms/views/finance/billDetails/BillDetails.vue')
    },
    {
        path: '/bms/settle',
        name: 'settleIndex',
        meta: { title: 'BMSLang.route.bill', icon: 'bill', system: 'bms' },
        component: () => import('./bms/views/finance/settle/Index.vue')
    },
    {
        path: '/bms/settleDetails',
        name: 'SettleDetails',
        meta: { title: 'BMSLang.route.SettleDetails', icon: 'SettleDetails', system: 'bms' },
        component: () => import('./bms/views/finance/settleDetails/SettleDetails.vue')
    },

    {
        path: '/bms/deposit',
        name: 'depositIndex',
        meta: { title: 'BMSLang.route.deposit', icon: 'deposit', system: 'bms' },
        component: () => import('./bms/views/finance/deposit/Index.vue')
    },
    {
        path: '/bms/depositDetails',
        name: 'DepositDetails',
        meta: { title: 'BMSLang.route.DepositDetails', icon: 'DepositDetails', system: 'bms' },
        component: () => import('./bms/views/finance/depositDetails/DepositDetails.vue')
    },
    {
        path: '/bms/cost',
        name: 'costIndex',
        meta: { title: 'BMSLang.route.cost', icon: 'cost', system: 'bms' },
        component: () => import('./bms/views/finance/cost/Index.vue')
    },
    {
        path: '/bms/distribution',
        name: 'distributionDetail',
        meta: { title: 'BMSLang.route.distribution', icon: 'Distribution', system: 'bms' },
        component: () => import('./bms/views/finance/distribution/Index.vue')
    },
    {
        path: '/bms/install',
        name: 'installDetail',
        meta: { title: 'BMSLang.route.install', icon: 'Distribution', system: 'bms' },
        component: () => import('./bms/views/finance/install/Index.vue')
    },
    {
        path: '/bms/networkDistribution',
        name: 'networkDistributionDetail',
        meta: { title: 'BMSLang.route.networkDistribution', icon: 'Distribution', system: 'bms' },
        component: () => import('./bms/views/finance/networkDistribution/Index.vue')
    },
    {
        path: '/bms/warehouse',
        name: 'warehouse',
        meta: { title: 'BMSLang.route.warehouse', icon: 'warehouse', system: 'bms' },
        component: () => import('./bms/views/finance/warehouse/Index.vue')
    },
    {
        path: '/bms/deliver',
        name: 'deliver',
        meta: { title: 'BMSLang.route.deliver', icon: 'deliver', system: 'bms' },
        component: () => import('./bms/views/finance/deliver/Index.vue')
    },
    {
        path: '/bms/loadAndUnload',
        name: 'loadAndUnload',
        meta: { title: 'BMSLang.route.loadAndUnload', icon: 'loadAndUnload', system: 'bms' },
        component: () => import('./bms/views/finance/loadAndUnload/Index.vue')
    },
    {
        path: '/bms/manualEstimate',
        name: 'manualEstimate',
        meta: { title: 'BMSLang.route.manualEstimate', icon: 'manualEstimate', system: 'bms' },
        component: () => import('./bms/views/finance/manualEstimate/Index.vue')
    },
    {
        path: '/bms/fine',
        name: 'fineIndex',
        meta: { title: 'BMSLang.route.fine', icon: 'fine', system: 'bms' },
        component: () => import('./bms/views/finance/fine/Index.vue')
    },
    {
        path: '/bms/fineDetails',
        name: 'fineDetailsIndex',
        meta: { title: 'BMSLang.route.fineDetails', icon: 'fineDetails', system: 'bms' },
        component: () => import('./bms/views/finance/fineDetails/Index.vue')
    },
    {
        path: '/bms/statement',
        name: 'statementIndex',
        meta: { title: 'BMSLang.route.statement', icon: 'bill', system: 'bms' },
        component: () => import('./bms/views/finance/statement/Index.vue')
    },
    {
        path: '/bms/statementDetails',
        name: 'StatementDetails',
        meta: { title: 'BMSLang.route.StatementDetails', icon: 'StatementDetails', system: 'bms' },
        component: () => import('./bms/views/finance/statementDetails/StatementDetails.vue')
    },
    {
        path: '/bms/invoiceRegistration',
        name: 'InvoiceRegistration',
        meta: { title: 'BMSLang.route.invoiceRegistration', icon: 'StatementDetails', system: 'bms' },
        component: () => import('./bms/views/finance/invoiceRegistration/Index.vue')
    },
    {
        path: '/bms/invoiceManage',
        name: 'InvoiceManage',
        meta: { title: 'BMSLang.route.invoiceManage', icon: 'StatementDetails', system: 'bms' },
        component: () => import('./bms/views/finance/invoiceManage/Index.vue')
    },
    {
        path: '/bms/invoiceManage/details',
        name: 'InvoiceManageDetails',
        meta: { title: '发票详情', icon: 'StatementDetails', system: 'bms' },
        component: () => import('./bms/views/finance/invoiceManage/Details.vue')
    },
    {
        path: '/bms/noTaxDebtProof',
        name: 'NoTaxDebtProof',
        meta: { title: 'BMSLang.route.noTaxDebtProof', icon: 'StatementDetails', system: 'bms' },
        component: () => import('./bms/views/finance/noTaxDebtProof/Index.vue')
    }
];
